import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import Form from '../../components/Form';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Dimmer from '../../components/Dimmer';
import Button from '../../components/Button';

import './styles.css';

export const messages = defineMessages({
  save: {
    id: 'contact-notes.save',
    defaultMessage: 'Save',
  },
  error: {
    id: 'contact-notes.error',
    defaultMessage: 'Cannot save notes',
  },
  notesTitle: {
    id: 'contact-notes.notesTitle',
    defaultMessage: 'Notes',
  },
  notes: {
    id: 'contact-notes.notes',
    defaultMessage: 'Type in your notes',
  },
  addNotes: {
    id: 'contact-notes.addNotes',
    defaultMessage: 'Add Notes',
  },
  editNotes: {
    id: 'contact-notes.editNotes',
    defaultMessage: 'Edit',
  },
});

const MAX_NOTES_DISPLAY = 250;
const NOTES_MAX_LENGTH = 1000;

class ContactNotes extends React.PureComponent {
  static propTypes = {
    notes: PropTypes.string,
    contact: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    changeRepVisitsContactNotes: PropTypes.func.isRequired,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    const _state = {
      notes: props.notes,
      requesting: false,
      changeNotes: false,
      error: false,
    };

    if (props.notes) {
      _state.showSubNote = props.notes.length > MAX_NOTES_DISPLAY;
      _state.subNote = props.notes.substring(0, MAX_NOTES_DISPLAY);
    }

    this.state = _state;
  }

  onChange = (e, { value } = {}) => {
    value = value || e.target.value;
    this.setState({ notes: value });
  };

  saveNotes = () => {
    const { notes } = this.state;
    const { contact, changeRepVisitsContactNotes } = this.props;

    const onSuccess = () => {
      this.setState({
        showSubNote: notes.length > MAX_NOTES_DISPLAY,
        subNote: notes.substring(0, MAX_NOTES_DISPLAY),
        requesting: false,
        error: false,
      });
      this.switchChangeNotes();
    };

    const onFailure = () => {
      this.setState({
        requesting: false,
        error: true,
      });
    };

    this.setState({ requesting: true });

    changeRepVisitsContactNotes({
      variables: {
        input: {
          contact: {
            id: contact.id,
            notes,
          },
        },
      },
    }).then(onSuccess).catch(onFailure);
  };

  switchChangeNotes = () => {
    this.setState((prevState) => ({
      changeNotes: !prevState.changeNotes,
    }));
  };

  toggleSubNote = () => {
    this.setState((prevState) => ({ showSubNote: !prevState.showSubNote }));
  };

  render() {
    const { requesting, notes, changeNotes, subNote, showSubNote, error } = this.state;
    const { intl } = this.props;

    if (changeNotes) {
      return (
        <Dimmer.Dimmable styleName="contact-notes-container" data-cy="contact-notes-container">
          <Dimmer
            role="progressbar"
            aria-busy={requesting}
            inverted
            active={requesting}
          >
            <Loader active={requesting} />
          </Dimmer>
          <Form.TextArea
            rows="6"
            name="contact-notes"
            aria-label={intl.formatMessage(messages.notes)}
            value={notes}
            autoFocus
            onChange={this.onChange}
            maxLength={NOTES_MAX_LENGTH}
          />
          {error && (
          <Message error styleName="text-center">
            <FormattedMessage {...messages.error} />
          </Message>
          )}
          <Button basic onClick={this.saveNotes}>
            <FormattedMessage {...messages.save} />
          </Button>
        </Dimmer.Dimmable>
      );
    } else if (notes) {
      return (
        <div styleName="notes" data-cy="contact-notes">
          <h3><FormattedMessage {...messages.notesTitle} /></h3>
          <p>{showSubNote ? subNote : notes}</p>
          <div>
            {showSubNote && (
            <Button basic onClick={this.toggleSubNote}>
            &nbsp;...
            </Button>
            )}
            <Button basic onClick={this.switchChangeNotes}>
              <FormattedMessage {...messages.editNotes} />
            </Button>
          </div>
        </div>
      );
    } else {
      return (
        <Button basic onClick={this.switchChangeNotes}>
          <b><FormattedMessage {...messages.addNotes} /></b>
        </Button>
      );
    }
  }
}

export default injectIntl(ContactNotes);
